"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentFailureData = void 0;
var runtypes_1 = require("runtypes");
var runtypeImplementing_1 = require("../../../util/runtypeImplementing");
var UUID_1 = require("../../../util/UUID");
var Data_1 = require("./Data");
// Message format for sending payment failure push notifications
exports.PaymentFailureData = (0, runtypeImplementing_1.runtypeImplementing)(Data_1.Data)((0, runtypes_1.Record)({
    type: (0, runtypes_1.Literal)("paymentFailure"),
    customerUuid: UUID_1.UUID,
    charge: runtypes_1.String,
    referenceId: runtypes_1.String,
    vendorName: runtypes_1.String,
    orderUuid: UUID_1.UUID,
    failureCode: (0, runtypes_1.Union)((0, runtypes_1.Literal)("AUTHENTICATION_REQUIRED"), (0, runtypes_1.Literal)("STRIPE_REQUEST_INPUT"), (0, runtypes_1.Literal)("AMOUNT_TOO_SMALL"), (0, runtypes_1.Literal)("AMOUNT_TOO_LARGE"), (0, runtypes_1.Literal)("BALANCE_INSUFFICIENT"), (0, runtypes_1.Literal)("CARD_DECLINED"), (0, runtypes_1.Literal)("EXPIRED_CARD"), (0, runtypes_1.Literal)("OTHER")),
    action: (0, runtypes_1.Union)((0, runtypes_1.Literal)("CHECKOUT"), (0, runtypes_1.Literal)("ADJUSTMENT"), (0, runtypes_1.Literal)("REFUND")),
}).And((0, runtypes_1.Partial)({
    failureMessage: runtypes_1.String,
})));
//# sourceMappingURL=PaymentFailureData.js.map